function config() {
	//https://testparking.htfa.cn
	//https://parking.htfa.cn
    this.api_url = 'https://parking.htfa.cn';
    // this.api_url = 'http://127.0.0.1:19084';
    this.img_url = 'https://parking.htfa.cn';
    this.order_url = 'wss://parking.htfa.cn/ws/biz/order';
}
export default new config;